import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import './assets/style/im.scss';
import './assets/iconfont/iconfont.css';
import { createPinia, PiniaVuePlugin } from 'pinia'
import i18n from './i18n'
import httpRequest from './api/httpRequest';
import * as socketApi from './api/wssocket';
import * as messageType from './api/messageType';
import * as messageUtil from './api/messageUtil';
import emotion from './api/emotion.js';
import url from './api/url.js';
import str from './api/str.js';
import element from './api/element.js';
import * as  enums from './api/enums.js';
import * as dict from './api/dict.js';
import * as  date from './api/date.js';
import './utils/directive/dialogDrag';
import useChatStore from './store/chatStore.js'
import useFriendStore from './store/friendStore.js'
import useGroupStore from './store/groupStore.js'
import useServiceStore from './store/serviceStore.js'
import useUserStore from './store/userStore.js'
import useConfigStore from './store/configStore.js'

Vue.use(PiniaVuePlugin)
const pinia = createPinia()
// element-ui
Vue.use(ElementUI);
// 挂载全局
Vue.prototype.$wsApi = socketApi;
Vue.prototype.$msgType = messageType;
Vue.prototype.$msgUtil = messageUtil;
Vue.prototype.$date = date;
Vue.prototype.$http = httpRequest // http请求方法
Vue.prototype.$emo = emotion; // emo表情
Vue.prototype.$url = url; // url转换
Vue.prototype.$str = str; // 字符串相关
Vue.prototype.$elm = element; // 元素操作
Vue.prototype.$enums = enums; // 枚举
Vue.prototype.$dict = dict; // 字典
Vue.prototype.$eventBus = new Vue(); // 全局事件
Vue.config.productionTip = false;

/**
 * 从链接参数中获取登录信息(参考 uniapp App.vue 中 onLaunch 的处理)
 * 链接格式: http://xxxx/?data=xxx 或 http://xxxx/#/login?data=xxx
 * data内支持三种结构: {accessToken, refreshToken} / {loginInfo: {}} / {data: {}}
 */
const getLoginInfoFromUrl = () => {
	let dataParam = null;
	try {
		const href = window.location.href || '';
		const index = href.indexOf('?');
		if (index > -1) {
			// hash路由下参数可能跟在 #/ 后面, 这里统一在第一个 ? 之后截取, 并去掉hash部分
			const query = href.slice(index + 1).split('#')[0];
			const item = query.split('&').find(param => param.split('=')[0] === 'data');
			dataParam = item ? item.slice(item.indexOf('=') + 1) : null;
		}
	} catch (e) {
		console.error("读取链接参数失败:", e);
	}
	if (!dataParam) {
		return null;
	}
	try {
		let data = null;
		try {
			data = JSON.parse(decodeURIComponent(dataParam));
		} catch (e) {
			// 兼容参数未做url编码的情况
			data = JSON.parse(dataParam);
		}
		// 按照登录流程处理数据
		const loginInfo = data.loginInfo || data.data || data;
		if (loginInfo && (loginInfo.accessToken || loginInfo.refreshToken)) {
			return loginInfo;
		}
		console.error("链接参数中没有有效的登录信息");
	} catch (e) {
		console.error("链接参数解析失败:", e);
	}
	return null;
}

/**
 * 处理链接参数中的登录信息, 有则保存token并直接进入聊天页
 * 注意: 客户端(app://协议)加载时地址中不带data参数, 不会生效, 不影响安装包
 */
const handleUrlLoginInfo = () => {
	const loginInfo = getLoginInfoFromUrl();
	if (!loginInfo) {
		return;
	}
	// 保存token
	if (loginInfo.accessToken) {
		sessionStorage.setItem("accessToken", loginInfo.accessToken);
	}
	if (loginInfo.refreshToken) {
		sessionStorage.setItem("refreshToken", loginInfo.refreshToken);
	}
	// 清除地址栏中的参数, 并将初始地址指向聊天页
	// 此时路由还未初始化, 会以该地址作为初始路由直接渲染聊天页, 不会先渲染登录页
	// 这里不能用router.push: 聊天页为懒加载路由, push的导航会因应用初始化的导航而被取消
	try {
		window.history.replaceState({}, document.title, window.location.pathname + '#/home/chat');
	} catch (e) {
		console.error("清除地址栏参数失败:", e);
	}
}

handleUrlLoginInfo();

new Vue({
  el: '#app',
  // 配置路由
  router,
  pinia,
  i18n,
  render: h => {
    // 挂载全局的pinia
    Vue.prototype.chatStore = useChatStore();
    Vue.prototype.friendStore = useFriendStore();
    Vue.prototype.groupStore = useGroupStore();
    Vue.prototype.serviceStore = useServiceStore();
    Vue.prototype.userStore = useUserStore();
    Vue.prototype.configStore = useConfigStore();

    return h(App)
  }
})


